import { useCallback } from 'react';
import type { UseMutationResult } from '@tanstack/react-query';
import useTranslation from './useTranslation';

type MutationStatus = UseMutationResult['status'];

type ButtonTextConfig = {
  status?: MutationStatus;
  isSubmitting: boolean;
  hasChanges: boolean;
  labels?: {
    saving?: string;
    allSaved?: string;
    noChanges?: string;
    saveChanges?: string;
  };
};

export const useFormButtonText = () => {
  const { lang } = useTranslation();

  const getButtonText = useCallback(
    ({ status, isSubmitting, hasChanges, labels = {} }: ButtonTextConfig) => {
      const {
        saving = 'msg.saving',
        allSaved = 'msg.allSaved',
        noChanges = 'msg.noChanges',
        saveChanges = 'msg.saveChanges',
      } = labels;

      if (status === 'pending' || isSubmitting) return lang.get(saving);
      if (status === 'success' && !hasChanges) return lang.get(allSaved);
      if (!hasChanges) return lang.get(noChanges);
      return lang.get(saveChanges);
    },
    [lang],
  );

  return { getButtonText };
};
